import { Component } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-xero',
  templateUrl: './xero.component.html',
  styleUrls: ['./xero.component.scss'],
  providers: [MessageService]
})
export class XeroComponent {
  error: boolean = false;
  errorMessage: string = "";
  isLoading: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    public router: Router,
    public messageService: MessageService, 
  ) {}

  ngOnInit(){
    //this.startXeroSignup();
  }

  startXeroSignup(){
    this.error = false;
    this.errorMessage = "";
    this.isLoading = true;

    this.authenticationService.xeroAuthRequest().subscribe(response => {
      window.location.href = response;
    },
    err =>{
      this.error = true;
      this.errorMessage = "Failed to start Xero sign up process";
      this.isLoading = false;
    });
  }

  home(){
    this.router.navigateByUrl('/');
  }
}
